/*
 *  Author: DL
 *  Date: 2020-12-03 17:04:15
 *  Email: dunaliang@fengmap.com
 *  LastEditTime: 2020-12-11 10:54:00
 *  LastEditors: DL
 *  Description: 按钮
 *  Copyright: Copyright 2014 - 2020, FengMap, Ltd. All rights reserved.
 */

import React from 'react';
import classnames from 'classnames';
import styles from './index.less';

export default function(props) {
    const { className, block, ...attribute } = props;

    const bttnClass = classnames({
        [`${styles.bttn}`]: true,
        [`${styles.primary}`]: props.type === 'primary',
        [`${className}`]: !!className,
        [`${styles.block}`]: block,
        [`${styles.content}`]: !Array.isArray(props.children),
    });

    return (
        <button className={bttnClass} {...attribute}>
            {props.children}
        </button>
    );
}
